import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-empty-state.css';
var getClassNameList = classNames.bind(styles);
var UitkEmptyStateActionArea = function (props) {
  var children = props.children;
  var baseClassName = 'uitk-empty-state';
  return children ? React.createElement("div", {
    className: getClassNameList("".concat(baseClassName, "-action-area"))
  }, children) : null;
};
UitkEmptyStateActionArea.displayName = 'UitkEmptyStateActionArea';
export { UitkEmptyStateActionArea };